import React from 'react';

import { useAppContext } from '@/contexts/AppContext';
import useAuth from '@/hooks/useAuth';
import ForgotPassword from '@/pages/Auth/ForgotPassword';
import PasswordExpired from '@/pages/Auth/PasswordExpired';
import ResetPassword from '@/pages/Auth/ResetPassword';
import SetPassword from '@/pages/Auth/SetPassword';
import { setBodyClassWithRole } from '@/services/roleService';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Switch, Route, Redirect } from 'react-router-dom';
import PageLoading from '../components/PageLoading';
import NoLayoutRoute from '../components/routes/NoLayoutRoute';
import LoginPage from '@/pages/Auth/Login';
import AuthLayout from './cms';
import authService from '@/services/authService';
import LogoutPage from '@/pages/Auth/LogoutPage';

export default function RenderRoutes() {
  const { auth, authLoaded } = useAppContext();
  const [, i18n] = useTranslation();

  React.useEffect(() => {
    if (auth) {
      const callbackFunction = () => {
        if (auth.id !== authService.getLoginInfo()?.userId) {
          window.location.reload();
        }
      };
      document.addEventListener('visibilitychange', callbackFunction);
      return () => {
        document.removeEventListener('visibilitychange', callbackFunction);
      };
    }
    return () => {};
  }, [auth]);
  useAuth();
  React.useEffect(() => {
    if (auth?.roleClaims?.length) {
      setBodyClassWithRole(auth.roleClaims[0]);
    }
  }, [auth]);
  if (!authLoaded) {
    return <PageLoading />;
  }

  return (
    <>
      <Helmet htmlAttributes={{ lang: i18n.language }} />
      {auth ? (
        <>
          {auth.isPasswordExpired ? (
            <Switch>
              <NoLayoutRoute exact path={'/cms/logout'} component={LogoutPage} />
              <Route path="/cms/password-expired" component={PasswordExpired} exact />
              <Redirect from="*" to="/cms/password-expired" />
            </Switch>
          ) : (
            <Switch>
              <NoLayoutRoute exact path={'/cms/logout'} component={LogoutPage} />
              <Route path="/cms/" component={AuthLayout} />
            </Switch>
          )}
        </>
      ) : (
        <Switch>
          <NoLayoutRoute exact path={'/cms/change-password'} component={SetPassword} />
          <NoLayoutRoute exact path={'/cms/login'} component={LoginPage} />
          <NoLayoutRoute exact path={'/cms/logout'} component={LogoutPage} />
          <NoLayoutRoute exact path={'/cms/forgot-password'} component={ForgotPassword} />
          <NoLayoutRoute exact path={'/cms/reset-password/:token'} component={ResetPassword} />
          <Redirect from="*" to="/cms/login" />
        </Switch>
      )}
    </>
  );
}
